import { useEffect } from "react";
import { ReactLenis, useLenis } from "lenis/react";

const AnchorHandler = () => {
  const lenis = useLenis();
  useEffect(() => {
    if (!lenis) return;
    window.__lenis = lenis;
    const handler = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (!id || id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80, duration: 1.4 });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [lenis]);
  return null;
};

export const SmoothScroll = ({ children }) => (
  <ReactLenis root options={{ lerp: 0.09, duration: 1.3, smoothWheel: true, wheelMultiplier: 1 }}>
    <AnchorHandler />
    {children}
  </ReactLenis>
);
